export default __webpack_public_path__ + "static/media/deleteIcon.5243861f.svg";